const processInclude = require('base/util');

$(() => {
  processInclude(require('./stores/cities'));
});
